import { useEffect, useRef } from 'react';
import { message } from 'antd';
import type { CheckoutSuccessResult } from '../utils/buildReceiptData';

interface CheckoutSuccessDialogProps {
  open: boolean;
  result: CheckoutSuccessResult | null;
  onContinue: () => void;
}

const TOAST_DURATION_SECONDS = 3;

/**
 * Giữ tên export để không làm vỡ các caller cũ, nhưng không còn render dialog.
 * Khi đơn được tạo xong, component hiển thị toast trên đầu màn hình rồi gọi
 * callback điều hướng; antd tự đóng toast sau thời lượng cấu hình.
 */
export function CheckoutSuccessDialog({
  open,
  result,
  onContinue,
}: CheckoutSuccessDialogProps) {
  const notifiedOrderRef = useRef<string | null>(null);

  useEffect(() => {
    if (!open || !result || notifiedOrderRef.current === result.orderCode) return;

    notifiedOrderRef.current = result.orderCode;
    if (result.dispatchError) {
      void message.warning({
        content: `Đã tạo đơn #${result.orderCode}, nhưng chưa gửi được sang đơn vị vận chuyển: ${result.dispatchError}`,
        duration: 5,
      });
    } else {
      void message.success({
        content: `Tạo đơn #${result.orderCode} thành công`,
        duration: TOAST_DURATION_SECONDS,
      });
    }
    onContinue();
  }, [open, result, onContinue]);

  useEffect(() => {
    if (!open) notifiedOrderRef.current = null;
  }, [open]);

  return null;
}
